import(/* webpackMode: "eager" */ "/tmp/build_9d801687/lifemeasure-frontend/node_modules/@mui/material/Skeleton/index.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_9d801687/lifemeasure-frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_9d801687/lifemeasure-frontend/src/app/(charts)/bmi-charts/componets/BMIChartsClientSIde.js");
;
import(/* webpackMode: "eager", webpackExports: ["formulateGenderFromUrlFragment","calculateDobPerLocation","formulateChartUrl"] */ "/tmp/build_9d801687/lifemeasure-frontend/src/utils/intermediary_url_service.js");
